module.exports = __webpack_public_path__ + "img/canbadge_rectangle_tate_line.2462664c.png";